module.exports = __webpack_public_path__ + "stylesheets/footer_28f9620763476b57fd33ffbdcf7af323.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/footer.less
// module id = fAML
// module chunks = 154